import React from "react";
import { Container, Image, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Apps", path: "/apps" },
  { label: "Contact", path: "/contact" },
];

const AppNavBar = () => {
  const cvdsIcon = require("../assets/logos/cvdsLogoCropped.png");
  const { pathname } = useLocation();

  return (
    <Navbar
      className="navbar-dark"
      collapseOnSelect
      expand="lg"
      sticky="top"
      style={styles.navBar}
    >
      <Container>
        <Navbar.Brand as={Link} to="/">
          <Image src={cvdsIcon} height="26" alt="Cross Vision Development Studios" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            {navItems.map((item) => (
              <Nav.Link
                key={item.path}
                as={Link}
                to={item.path}
                eventKey={item.path}
                className={`nav-links${
                  pathname === item.path ||
                  (item.path !== "/" && pathname.startsWith(`${item.path}/`))
                    ? " nav-links-active"
                    : ""
                }`}
                style={styles.link}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavBar;

const styles = {
  link: {
    color: "#FFF",
    fontWeight: 600,
    fontSize: 16,
    textDecoration: "none",
    marginLeft: 8,
  },
  navBar: {
    backgroundColor: "#1C1816",
    minHeight: 64,
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.5)",
  },
};
